export default __webpack_public_path__ + "static/media/full_image.44cebfcb.svg";